import script from "./pre-tenancy-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./pre-tenancy-modal.vue?vue&type=script&setup=true&lang=ts"

import "./pre-tenancy-modal.vue?vue&type=style&index=0&id=71db8723&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71db8723"]])

export default __exports__